import React from 'react';

export default function LoadingOverlay() {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <img
          src="/horse-running-loading.gif"
          alt="Loading..."
          className="mx-auto mb-4 w-32"
        />
        <p className="text-lg font-medium text-gray-900">Loading. Please Wait...</p>
      </div>
    </div>
  );
} 